<div class="policy-page">
  <div class="policy-container">
    <h1>PRIVACY POLICY</h1>

    <p class="brand-name"><strong>Pixie Pets</strong></p>
    <p class="last-updated"><em>Last updated: 22.12.2025</em></p>

    <hr>

    <h2>1. Introduction</h2>
    <p>At Pixie Pets, your privacy matters to us.</p>
    <p>This Privacy Policy explains how we collect, use, and protect your personal data when you use our website and services.</p>

    <hr>

    <h2>2. Who we are</h2>
    <p>Pixie Pets is operated by:</p>
    <p><strong>Team Up Recruitment sp. z o.o.</strong><br>
    ul. Sienkiewicza 72<br>
    90-318 Łódź<br>
    Poland<br>
    VAT ID: PL7252288257</p>
    <p>If you have any questions about this policy or your data, you can contact us at:<br>
    <a [href]="'mailto:' + supportEmail"><strong>{{ supportEmail }}</strong></a></p>

    <hr>

    <h2>3. What data we collect</h2>
    <p>We may collect the following personal data:</p>
    <ul>
      <li>Email address</li>
      <li>Uploaded pet photos</li>
      <li>Shipping and billing information</li>
      <li>Order details and purchase history</li>
      <li>Communication with our support team</li>
    </ul>
    <p>Payments are processed securely by third-party payment providers.<br>
    Pixie Pets <strong>does not store payment card details</strong>.</p>

    <hr>

    <h2>4. How we use your data</h2>
    <p>We use your personal data to:</p>
    <ul>
      <li>Create and fulfill your orders</li>
      <li>Communicate with you about your order or delivery</li>
      <li>Provide customer support</li>
      <li>Send updates, promotions, or product news if you choose to subscribe</li>
    </ul>
    <p>We do <strong>not sell</strong> your personal data.</p>

    <hr>

    <h2>5. Pet photos</h2>
    <p>Uploaded pet photos are used <strong>only</strong> to:</p>
    <ul>
      <li>create your personalized artwork</li>
      <li>fulfill your order</li>
    </ul>
    <p>Your pet photos are <strong>not used for marketing or shared publicly</strong> without your explicit permission.</p>

    <hr>

    <h2>6. Third-party services</h2>
    <p>To operate Pixie Pets, we work with trusted third-party partners, including:</p>
    <ul>
      <li>printing and fulfillment providers</li>
      <li>shipping and logistics partners</li>
      <li>payment processors</li>
      <li>email and communication services</li>
    </ul>
    <p>These partners receive only the data necessary to perform their services and are required to process it in accordance with applicable data protection laws.</p>

    <hr>

    <h2>7. Data retention</h2>
    <p>We keep your personal data only as long as necessary to:</p>
    <ul>
      <li>fulfill your order</li>
      <li>meet legal, accounting, and tax obligations</li>
    </ul>
    <p>Pet photos and order-related data may be retained for a limited time to handle customer support or quality issues.</p>

    <hr>

    <h2>8. Your rights</h2>
    <p>You have the right to:</p>
    <ul>
      <li>access your personal data</li>
      <li>request correction or deletion of your data</li>
      <li>object to or restrict certain processing</li>
      <li>unsubscribe from marketing emails at any time</li>
    </ul>
    <p>To exercise your rights, contact us at:<br>
    <a [href]="'mailto:' + supportEmail"><strong>{{ supportEmail }}</strong></a></p>

    <hr>

    <h2>9. Policy updates</h2>
    <p>We may update this Privacy Policy from time to time.<br>
    The most recent version will always be available on this page.</p>
  </div>
</div>
